import { render, staticRenderFns } from "./PesquisaAcessoInclusaoDigital.vue?vue&type=template&id=27cedc49&scoped=true"
import script from "./PesquisaAcessoInclusaoDigital.vue?vue&type=script&lang=js"
export * from "./PesquisaAcessoInclusaoDigital.vue?vue&type=script&lang=js"
import style0 from "./PesquisaAcessoInclusaoDigital.vue?vue&type=style&index=0&id=27cedc49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cedc49",
  null
  
)

export default component.exports